import React, { useCallback, useEffect, useState } from "react";

import ClientSearch from "../clientSearch/ClientSearch";
import HistoryCard from "../historyCard/HistoryCard";
import Loading from "../loading/Loading";
import NoResults from "../noResults/noResults";
import { getCustomerLogsByIdService } from "../../services/logs/services";

const getLocalISOString = () => {
  const now = new Date();
  return new Date(
    now.getTime() - now.getTimezoneOffset() * 60000,
  ).toISOString();
};

const getFirstDayOfMonthISOString = () => {
  const now = new Date();
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  return new Date(
    firstDay.getTime() - firstDay.getTimezoneOffset() * 60000,
  ).toISOString();
};

const ClientHistory = ({ clientId }) => {
  const [type, setType] = useState("all");
  const [histories, setHistories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dateFrom, setDateFrom] = useState(getFirstDayOfMonthISOString());
  const [dateTo, setDateTo] = useState(getLocalISOString());
  const [getAll, setGetAll] = useState(false);

  const fetchHistories = useCallback(async () => {
    if (!clientId) return;
    try {
      setIsLoading(true);
      const { logs = [] } = await getCustomerLogsByIdService({
        customerId: clientId,
        category: type,
        dateFrom,
        dateTo,
        getAll,
      });
      setHistories(logs);
    } catch (error) {
      console.error("Error fetching customer logs:", error);
      setHistories([]);
    } finally {
      setIsLoading(false);
    }
  }, [clientId, type, dateFrom, dateTo, getAll]);

  useEffect(() => {
    fetchHistories();
  }, [fetchHistories]);

  const renderContent = () => {
    if (isLoading) return <Loading width="10" height="10" />;
    if (!histories.length) return <NoResults message="No history found" />;
    return <HistoryCard histories={histories} />;
  };

  return (
    <div className="grid gap-6 mb-6 md:grid-cols-1">
      <ClientSearch
        type={type}
        setType={setType}
        setDateFrom={setDateFrom}
        setDateTo={setDateTo}
        setGetAll={setGetAll}
      />
      {renderContent()}
    </div>
  );
};

export default ClientHistory;
